import img from './img';
import audio from './audio';
import gameData from './gameData.config.js';

var config = {
  author: 'TR',
  engine: 'Steps',
  title: [
    {
      text: 'Zobacz, jak należy uruchomić program Paint i zamknąć jego okno. Klikaj w kolejne liczby.',
      audio: 'games/page005_game1/audio/z5c1.mp3',
    },
  ],
  checkGameSound: {
    positive: 'games/page003_game4/audio/z3c4-brawo.mp3',
    // negative: 'games/page001_game1/audio/z1c1-brawo.mp3',
  },
  checkGameText: {
    positive: 'Ćwiczenie zostało wykonane. Brawo! ',
    negative: '',
  },
  gameConfig: gameData,
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

// console.log( 'config', config );
export default config;
